import type { ReactNode } from 'react'

import { Table } from '@components/molecules/Table'

const rows: [string, string, string][] = [
  [
    'Picking an option',
    'Changes what shows in a card, rail or list, on the same page.',
    'Goes to a sibling section of the page.',
  ],
  [
    'In this app',
    'Cards or Table on the supporters page. The layout switch on the event roster.',
    "A group's sections.",
  ],
  [
    'Where it sits',
    'At the top of the card or section it switches, or in a toolbar next to search and filters.',
    'Under the page header.',
  ],
  ['Options', 'Two to four short labels.', 'As many as the section needs.'],
]

function Heading({ children }: { children: ReactNode }) {
  return <h3 className="tw:text-sm tw:font-semibold tw:text-gray-cool-900">{children}</h3>
}

function Text({ children }: { children: ReactNode }) {
  return <p className="tw:max-w-prose tw:text-sm tw:text-gray-cool-700">{children}</p>
}

export function ChoosingControlOrNav() {
  return (
    <div className="tw:flex tw:flex-col tw:gap-4">
      <Text>
        Use a segmented control to switch between a few views of one area on the same page. Use the page header nav to
        go to the sections of a page, each with its own URL.
      </Text>
      <div className="tw:overflow-hidden tw:rounded-xl tw:border tw:border-gray-cool-200">
        <Table.Root>
          <Table.Header className="tw:bg-gray-cool-50">
            <Table.Row>
              <Table.Head>When</Table.Head>
              <Table.Head>SegmentedControl</Table.Head>
              <Table.Head>Page header nav (PageHeaderNav)</Table.Head>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {rows.map(([label, ...cells]) => (
              <Table.Row key={label}>
                <Table.Cell className="tw:whitespace-nowrap tw:align-top tw:text-sm tw:font-medium tw:text-gray-cool-900">
                  {label}
                </Table.Cell>
                {cells.map((cell) => (
                  <Table.Cell key={cell} className="tw:align-top tw:text-sm tw:text-gray-cool-700">
                    {cell}
                  </Table.Cell>
                ))}
              </Table.Row>
            ))}
          </Table.Body>
        </Table.Root>
      </div>
      <Heading>Borderline cases</Heading>
      <ul className="tw:flex tw:list-disc tw:flex-col tw:gap-1 tw:pl-4 tw:text-sm tw:text-gray-cool-700">
        <li>A choice inside a form is a radio group, or a select for five or more options.</li>
        <li>Options that can be combined are checkboxes or a multiselect.</li>
      </ul>
    </div>
  )
}
